import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Helpers } from 'shared-components/helpers/helpers';

export class List extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      value: null
    };
    this.handleClick = this.handleClick.bind(this);
    this.appendList = this.appendList.bind(this);
    this.renderDropdownListContainer = this.renderDropdownListContainer.bind(this);
  }

  handleClick (e) {
    const isMobile = Helpers.isMobile();
    let dataValue;

    if (isMobile) {
      dataValue = e.currentTarget.selectedOptions[0].getAttribute('data-value');
    } else {
      dataValue = e.currentTarget.getAttribute('data-value');
    }

    this.props.listClick(dataValue, this.props.listToggle);
  }

  appendList (isMobile) {
    const {
      listPreferred = [],
      listData = [],
      selectedValue,
      listClassName = '',
      listKey,
      listContent,
      children
    } = this.props;
    const finalList = listPreferred.concat(listData);
    const list = _.map(finalList, (data, index) => {
      const highlight = (selectedValue === data) ? 'highlight' : '';
      const eleVal = (_.isString(data)) ? data : JSON.stringify(data);
      if (isMobile) {
        return (
          children ?
            React.cloneElement(children, { data, isMobile: true, index }) :
            <option
              key={`${listKey}-${index}`}
              value={eleVal}
              data-value={JSON.stringify(data)}
            >
              {listContent(data, true)}
            </option>
        );
      }
      return (
        <li
          role="option"
          key={`${listKey}-${index}`}
          className={`${listClassName} ${highlight}`}
          data-value={eleVal}
          onClick={this.handleClick}
        >
          {children ? React.cloneElement(children, { data }) : listContent(data)}
        </li>
      );
    });

    if (this.props.listPreferred && !isMobile && 0 < this.props.listPreferred.length) {
      // Added dashed line between preffered countries and the rest
      const dashedLi = (<li key={`${this.props.listKey}_divider`} className="divider" />);
      list.splice(this.props.listPreferred.length, 0, dashedLi);
    }
    return list;
  }

  renderDropdownListContainer () {
    const isMobile = Helpers.isMobile();
    if (isMobile) {
      return (
        <select
          onChange={this.handleClick}
          data-value={this.state.value}
          value={this.props.selectedValue}
        >
          {this.appendList(isMobile)}
        </select>
      );
    }
    return (
      <ul
        role="listbox"
        className={`dropdown-list ${this.props.ulClassName}`}
        aria-labelledby={null}
      >
        {this.appendList()}
      </ul>
    );
  }

  render () {
    return this.renderDropdownListContainer();
  }
}


List.propTypes = {
  listClick: PropTypes.func, // Function in the parent that manages what happens when user show clicks from dropdown.
  listToggle: PropTypes.func, // Function that closes dropdown after user clicks on a space. This function is an argument in the listClick funciton.
  listPreferred: PropTypes.array, // Items to display first on the list.
  listData: PropTypes.array, // The collection data for the list items.
  listContent: PropTypes.node, //
  listKey: PropTypes.string, // Unique name for the list of items.
  listClassName: PropTypes.string,
  ulClassName: PropTypes.string,
  selectedValue: PropTypes.string,
  children: PropTypes.object
};

List.defaultProps = {
  ulClassName: 'col-md-12'
};
